import React from 'react';
import Type from 'prop-types';
import { Form, Field, useFormikContext } from 'formik';
import { SimpleAutocomplete, EmailField } from 'components';
import { useTranslation } from 'hooks';
import { useCompanyCodes, useDebtorInfo } from 'hooks/api/cascade';
import { useContacts } from 'hooks/api/contact';
import { CascadeReportAction } from 'constants/actions';
import ActionField from '../../../ClaimScreen/components/ActionField';

const InvoiceForm = (props) => {
  const { entityId } = props;
  const { t } = useTranslation();
  const { isLoading: isCompanyCodesLoading, data: companyCodes } = useCompanyCodes(entityId);
  const { isSuccess: isDebtorSuccess, data: debtorInfo } = useDebtorInfo(entityId);
  const customerId = isDebtorSuccess ? debtorInfo?.debitor?.id : null;
  const {
    isLoading: isContactsLoading,
    isSuccess: isContactsSuccess,
    data: contacts,
  } = useContacts(customerId);
  const filteredContacts = isContactsSuccess ? contacts.filter((contact) => !!contact.email) : [];
  const { values } = useFormikContext();
  const { action } = values;

  return (
    <Form noValidate>
      <Field
        id="companyCode"
        name="companyCode"
        component={SimpleAutocomplete}
        getOptionLabel={(option) => option.name}
        options={companyCodes}
        fullWidth
        loading={isCompanyCodesLoading}
        TextFieldProps={{
          label: t('companyCode'),
          required: true,
        }}
      />

      <ActionField name="action" required />

      <EmailField
        name="email"
        loading={isContactsLoading}
        disabled={action !== CascadeReportAction.SEND_EMAIL}
        options={filteredContacts}
        fullWidth
        TextFieldProps={{
          label: t('email'),
        }}
      />
    </Form>
  );
};

InvoiceForm.propTypes = {
  entityId: Type.string.isRequired,
};

export default InvoiceForm;
